import {
    DICT_DEFAULT_RESOURCE_TEXT,
    DICT_ARIA_RESOURCE_TEXT,
    TIMESLOT_EVENTS,
    ModalStepsLabel,
    EventValues,
    EventTypes
} from "../utils/constants";
import { formatTimeSlot, removeTimezone } from "../utils/date";
import { getNextFocusIndex } from "../utils/keyboard";
import SectionComponent from "./section.component";

export default class TimeslotComponent extends SectionComponent {
    #resourcesService;
    #analyticsService;


    constructor() {
        super();
    }

    get noAvailableAppointmentsMessage() {
        return this.#resourcesService.getResource(
            "SELFSCHEDULER_NOAPPOINTMENTSFORSELECTEDDATE",
            DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_NOAPPOINTMENTSFORSELECTEDDATE
        );
    }

    init(resourcesService, analyticsService, culture, use24hourClock, aptDate){
        this.#resourcesService = resourcesService;
        this.#analyticsService = analyticsService;
        this.culture = culture;
        this.use24hourClock = use24hourClock;
        this.aptDate = aptDate;
    }

    createTimeslots(operatorTimeSlots) {
        let timeslotInfo = [];
        let result = this.noAvailableAppointmentsMessage;
        if (operatorTimeSlots && operatorTimeSlots.length != 0) {
            operatorTimeSlots.forEach((timeSlot) => {
                const slot = `${timeSlot.startTime}-${timeSlot.endTime}`;
                timeslotInfo.push(`
                <button id="v24ts~${slot}" data-starttime="${timeSlot.startTime}" data-endtime="${timeSlot.endTime}" class="btn v24-operator-timeslot">
                    ${formatTimeSlot(
                    this.aptDate,
                    timeSlot.startTime,
                    timeSlot.endTime,
                    this.culture,
                    this.use24hourClock
                )}
                </button>`);
            });
            result = timeslotInfo.join("");
        } else {
            const evtData = {date: this.aptDate, message: result}
            this.#analyticsService.send(EventTypes.Error, EventValues.NoAppointmentsForDateAvailable, ModalStepsLabel.appointmentSelectionStep, evtData);
        }
        const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
        let dateFormat = removeTimezone(new Date(this.aptDate)).toLocaleDateString(this.culture, options);
        let selectedDateInstructions =  this.#resourcesService.getResource(
            "SELFSCHEDULER_SELECTED_TIMESLOT_INSTRUCTIONS",
            DICT_DEFAULT_RESOURCE_TEXT.SELFSCHEDULER_SELECTED_TIMESLOT_INSTRUCTIONS
        ).replace("{0}",dateFormat);
        this.setInstructions(selectedDateInstructions);
        let ariaLabel = this.#resourcesService.getResource("SELFSCHEDULER_ARIA_TIMESLOT_INSTRUCTIONS", DICT_ARIA_RESOURCE_TEXT.SELFSCHEDULER_ARIA_TIMESLOT_INSTRUCTIONS)
        this.setContent(`<div id="v24AppointmentTimeSlots" tabindex="-1" class="v24-timeslot-loaded" role="group" aria-label="${ariaLabel}">${result}</div>`)
        this.addBtnClickEvents();
        this.querySelector(".v24-timeslot-loaded").focus();

    }

    addBtnClickEvents() {
        const timeslots = this.querySelectorAll(`.v24-operator-timeslot`);
        timeslots.forEach((timeslot, index) => {
            timeslot.addEventListener("click", (e) => {
                this.clearTimeSlots();
                this.chooseTimeSlot(e);
            });
            
            timeslot.addEventListener("keydown", (e) => {
                const nextIndex = getNextFocusIndex(e, index, timeslots.length);
                if (nextIndex !== null) {
                    timeslots[nextIndex].focus();
                }
            });
        });
    }

    chooseTimeSlot(event) {
        const timeSlot = event.target;
        if (timeSlot) {
            timeSlot.classList.add("v24-operator-timeslot-selected");
            timeSlot.setAttribute("aria-current", true);

            this.dispatchEvent(new CustomEvent(TIMESLOT_EVENTS.timeslotSelected, {
                bubbles: true,
                detail: {
                    startTime: timeSlot.dataset.starttime,
                    endTime: timeSlot.dataset.endtime,
                    appointmentTime: `${timeSlot.dataset.starttime}-${timeSlot.dataset.endtime}`
                }
            }));
        }
    }

    clearTimeSlots() {
        const prevSelectedBtns = this.querySelectorAll(".v24-operator-timeslot-selected");
        prevSelectedBtns.forEach(btn => {
            btn.classList.remove('v24-operator-timeslot-selected');
        })

    }

    clear() {
        this.setContent("");
        this.setInstructions("");
    }
}
